export default "__VITE_ASSET__25a87788__"